import {Component, inject, OnInit} from '@angular/core';
import {GraphicUtils} from '@aiknow-srl/aik-angular-sdk';
import {Router} from '@angular/router';
import {MatSidenav} from '@angular/material/sidenav';
import {Menu} from '../../Models/User/Menu';
import {Paths} from '../../Utils/paths';
import {BaseComponent} from "../common/BaseComponent";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseComponent implements OnInit {

  selectedItem?: string;

  graphicUtils = GraphicUtils;

  private route: Router = inject(Router);

  goto(item: Menu): void {
    this.gmService.menuVoice = item;
    this.selectedItem = item.id;
    this.route.navigateByUrl(`${Paths.HOME}/${item.path}`, {skipLocationChange: true});
  }

  ngOnInit(): void {

    if (this.gmService.isTenantAdmin()) {
      // @ts-ignore
      this.goto(this.gmService.user.menuItems.find(t => t.path === Paths.CUSTOMER_REGISTRY));
    } else if (this.gmService.isTenantUser()) {
      // @ts-ignore
      this.goto(this.gmService.user.menuItems.find(t => t.path === Paths.CUSTOMER_PRODUCT_ITEM_REGISTRY));
    }

  }

  clickAndClose(item: Menu, drawer: MatSidenav): void{
    this.goto(item);
    if (GraphicUtils.isScreenWidthGreater(this.gmService.SMALL_SCREEN_THRESHOLD)) {
      drawer.close();
    }
  }

}
